module.exports = __webpack_public_path__ + "static/media/S3N2-6.104d7c57.svg";